var React = require('react');

function UiArrowDownThin (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("g",{"id":"Approved-L2_x2F_L3","key":1},React.createElement("g",{"id":"V1_1","transform":"translate(-290.000000, -185.000000)"},React.createElement("g",{"id":"chevron_blue","transform":"translate(290.000000, 185.000000)"},React.createElement("polygon",{"id":"Path","points":"10.5,11.1 11.4,10.3 21,2.1 19.2,0 10.5,7.5 1.8,0 0,2.1 9.6,10.3 \t\t\t"}))))]);
}

UiArrowDownThin.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 21 11.1","style":{"enableBackground":"new 0 0 21 11.1"},"xmlSpace":"preserve"};

module.exports = UiArrowDownThin;

UiArrowDownThin.default = UiArrowDownThin;
